import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames/bind';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import styles from './RequestCallBackForm.module.scss';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import { formProgression, formError } from 'common/helpers/Gtm';
import PrefixSelect, {
  ICountryPrefix,
} from 'components/PhoneInput/PrefixSelect/PrefixSelect';
import { ICallBackTimeSlots } from 'features/CallBack/types';
import http from 'app/http';
import { useAppSelector } from 'app/hooks';
import { selectCoreSettings } from 'features/content/selectors';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { RegexNumber } from 'common/helpers/RegexNumber';
import { SvgIcons } from 'common/consts/svgIcons';
import Icon from 'components/Icon/Icon';
import { selectCurrentMarket } from 'features/core/selectors';
import { Market } from 'common/consts/markets';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

interface Props {
  Model: any;
  PageData: any;
  LayoutModel?: any;
  SetModelState?: any;
  SetPageDataState?: any;
  SetLayoutModelState?: any;
  ModelState?: any;
  PageDataState?: any;
  LayoutModelState?: any;
  FirstTimeSlotSectionSelected?: any;
  SetFirstTimeSlotSectionSelected?: any;
  HourSlots?: any;
}

const getDefaultPrefix = (prefixes: ICountryPrefix[]) =>
  (prefixes || []).find((prefix) => prefix.Selected);

const RequestCallBackForm = (props: Props) => {
  const {
    Model,
    PageData,
    LayoutModel,
    SetModelState,
    SetPageDataState,
    SetLayoutModelState,
    ModelState,
    PageDataState,
    LayoutModelState,
    FirstTimeSlotSectionSelected,
    SetFirstTimeSlotSectionSelected,
    HourSlots,
  } = props;
  const defaultPrefix = useMemo(
    () => getDefaultPrefix(Model?.CountryPrefixDropDown),
    [Model?.CountryPrefixDropDown],
  );
  const history = useHistory();
  const { executeRecaptcha } = useGoogleReCaptcha(); // Recaptcha v3

  const [disableContinueButton, setDisableContinueButton] =
    useState<Boolean>(true);

  const [isNotNull, setIsNotNull] = useState<Boolean>(false);
  const siteSettings = useAppSelector(selectCoreSettings);
  const [allRowShowed, setAllRowShowed] = useState<Boolean>(true);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const {
    control,
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    formState: { errors: errors, isValid },
  } = useForm({
    defaultValues: {
      FormModel: {
        FirstName: Model?.FormModel?.FirstName,
        LastName: Model?.FormModel?.LastName,
        PhoneNumber: Model?.FormModel?.PhoneNumber,
        ReferenceNumber: Model?.FormModel?.ReferenceNumber,
        CallFromDate: Model?.FormModel?.CallFromDate,
        CountryPrefixCode: defaultPrefix?.Value,
      },
    },
    mode: 'all',
  });

  const watchAllFields = watch();
  const currentMarket = useAppSelector(selectCurrentMarket);

  const setValuesWhenIsDirty = (name: string, value: string) => {
    setIsNotNull(true);
    setDisableContinueButton(true);

    if (watchAllFields) {
      let { ReferenceNumber, ...newPayload } = watchAllFields.FormModel;
      Object.values(newPayload).map((objValue) => {
        if (objValue === undefined || objValue === null || objValue === '') {
          setIsNotNull(false);
        }
      });
      let phone = newPayload.PhoneNumber;
      if (
        phone?.length < Model?.MobilePhoneNumberMinLength ||
        phone?.length > Model?.MobilePhoneNumberMaxLength
      ) {
        setIsNotNull(false);
      }
      if( currentMarket === Market.DE){
        if(ReferenceNumber === undefined || ReferenceNumber === null || ReferenceNumber === ''){

          setIsNotNull(false);
        }
        if (
          ReferenceNumber?.length < Model?.MobilePhoneNumberMinLength ||
          ReferenceNumber?.length > Model?.MobilePhoneNumberMaxLength
        )
        {
          setIsNotNull(false);
        }
      }
    }

    if (isNotNull) {
      setDisableContinueButton(false);
    }
  };

  function findDayTranslation(dayValue: string) {
    let dayProp = 'Day_' + dayValue?.toLowerCase() + '_name';
    let dayTranslatedValue =
      siteSettings?.PageData?.SiteSettings?.MarketTranslation?.[dayProp];
    return dayTranslatedValue || dayValue;
  }

  function findMonthTranslation(DateMonthValue: string) {
    let splittedValue = !isNullOrWhiteSpace(DateMonthValue)
      ? DateMonthValue?.split(' ')
      : [];
    let monProp = 'Month_' + splittedValue[1] + '_shortname';
    let monthTranslatedValue =
      siteSettings?.PageData?.SiteSettings?.MarketTranslation?.[monProp];
    let DateMonthTranslatedValue =
      monthTranslatedValue != undefined || monthTranslatedValue != null
        ? splittedValue[0] + ' ' + monthTranslatedValue
        : undefined;
    return DateMonthTranslatedValue || DateMonthValue;
  }

  const timeslotsOne = HourSlots?.CurrentDayTimeSlots?.map(
    (slot: ICallBackTimeSlots) => {
      return (
        <div className="button-radio ">
          <Controller
            control={control}
            name={'FormModel.CallFromDate'}
            render={({
              field: { onChange, name, value },
              fieldState: { isDirty, isTouched },
            }) => {
              if (isDirty || isTouched) {
                setValuesWhenIsDirty(name, value);
              }

              return (
                <>
                  <input
                    type="radio"
                    name={name}
                    value={slot.TimeSlotWithDate}
                    onChange={(e) => onRadioChange1(e, onChange)}
                    onBlur={(e) =>
                      formProgression(e, 'RequestCallBack', 'CallFromDate')
                    }
                  />
                </>
              );
            }}
          />

          <label className="btn btn-default">{slot.TimeSlot}</label>
        </div>
      );
    },
  );
  const timeslotsTwo = HourSlots?.NextDayTimeSlots?.map(
    (slot: ICallBackTimeSlots) => {
      return (
        <div className="button-radio ">
          <Controller
            control={control}
            name={'FormModel.CallFromDate'}
            render={({
              field: { onChange, name, value },
              fieldState: { isDirty, isTouched },
            }) => {
              if (isDirty || isTouched) {
                setValuesWhenIsDirty(name, value);
              }

              return (
                <>
                  <input
                    type="radio"
                    name={name}
                    value={slot.TimeSlotWithDate}
                    onChange={(e) => onRadioChange2(e, onChange)}
                    onBlur={(e) =>
                      formProgression(e, 'RequestCallBack', 'CallFromDate')
                    }
                  />
                </>
              );
            }}
          />
          <label className="btn btn-default">{slot.TimeSlot}</label>
        </div>
      );
    },
  );
  const onRadioChange1 = async (e: any, callback: Function) => {
    SetFirstTimeSlotSectionSelected(true);
    callback(e.target.value);
  };

  const onRadioChange2 = async (e: any, callback: Function) => {
    SetFirstTimeSlotSectionSelected(false);
    callback(e.target.value);
  };

  const onCallBackSubmit = async (data: any) => {
    data['FormModel']['DisableRecaptcha'] =
      ModelState?.FormModel?.DisableRecaptcha;
    if (ModelState?.FormModel?.DisableRecaptcha) {
      onCallBackSubmitHandle(data);
    } else {
      if (!executeRecaptcha) {
        return;
      }
      const token = await executeRecaptcha();

      if (token) {
        // Add recaptcha response to FormModel
        data.FormModel = {
          ...data.FormModel,
          RecaptchaResponseToken: token,
        };
        onCallBackSubmitHandle(data);
      } else {
        onCallBackSubmitHandle(data);
      }
    }
  };

  const onCallBackSubmitHandle = async (data: any) => {
    // Keep form data in local state
    //Get pathname from url
    const callMeBackUrl = getPathnameFromUrl(Model?.PostCallMeBackUrl);
    // Verification request
    try {
      setIsSubmitted(true);
      const response = await http.post(callMeBackUrl, qs.stringify(data));
      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        var nextPagePath = '';
        if (!response.data.RedirectUrl) {
          SetModelState(response.data.Model);
          SetPageDataState(response.data.PageData);
          SetLayoutModelState(response.data.LayoutModel);
        } else {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
          history.push(nextPagePath, {
            noRefresh: false,
          });
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitted(false);
    }
  };
  const handleMobileChange = (e: any) => {};
  var tagManagerArgs: any;

  useEffect(() => {
    if (errors.FormModel?.FirstName) {
      formError(
        'Call back request form',
        'FirstName',
        'error_Incorrect_First_Name',
      );
    }

    if (errors.FormModel?.LastName) {
      formError(
        'Call back request form',
        'LastName',
        'error_Incorrect_Last_Name',
      );
    }

    if (errors.FormModel?.PhoneNumber) {
      formError(
        'Call back request form',
        'PhoneNumber',
        'error_Incorrect_Phone_Number',
      );
    }

    if (errors.FormModel?.ReferenceNumber) {
      formError(
        'Call back request form',
        'ReferenceNumber',
        'error_Incorrect_Reference_Number',
      );
    }

    if (errors.FormModel?.CallFromDate) {
      formError(
        'Call back request form',
        'CallFromDate',
        'error_Incorrect_Call_From_Date',
      );
    }
  }, [errors]);
  const LOGO_ICONS_PATH = `${process.env.PUBLIC_URL}/images/logo/`;

  return (
    <>
      <form onSubmit={handleSubmit(onCallBackSubmit)}>
        <Controller
          control={control}
          name={'FormModel.FirstName'}
          rules={{
            pattern: {
              value: /^([^0-9]*)$/,
              message: PageData?.NameFieldErrorMessage,
            },
          }}
          render={({
            field: { onChange, name, value },
            fieldState: { isDirty },
          }) => {
            if (isDirty) {
              setValuesWhenIsDirty(name, value);
            }

            return (
              <>
                <div className={classNames('form-group  ')}>
                  <label className={styles.formlabel}>
                    {PageData?.FirstName}
                  </label>
                  <input
                    type="text"
                    name={name}
                    className="form-class"
                    value={value}
                    readOnly={Model?.FormModel?.FirstName !== null}
                    onChange={onChange}
                    onBlur={(e) =>
                      formProgression(e, 'RequestCallBack', 'firstName')
                    }
                  />
                  <p className={classNames('error', styles.errors)}>
                    {errors.FormModel?.FirstName?.message}
                  </p>
                </div>
              </>
            );
          }}
        />

        <Controller
          control={control}
          name={'FormModel.LastName'}
          rules={{
            pattern: {
              value: /^([^0-9]*)$/,
              message: PageData?.NameFieldErrorMessage,
            },
          }}
          render={({
            field: { onChange, name, value },
            fieldState: { isDirty },
          }) => {
            if (isDirty) {
              setValuesWhenIsDirty(name, value);
            }

            return (
              <>
                <div className={classNames('form-group')}>
                  <label className={styles.formlabel}>
                    {PageData?.LastName}
                  </label>
                  <input
                    type="text"
                    name={name}
                    className="form-class"
                    value={value}
                    onChange={onChange}
                    readOnly={Model?.FormModel?.LastName !== null}
                    onBlur={(e) =>
                      formProgression(e, 'RequestCallBack', 'LastName')
                    }
                  />
                  <p className={classNames('error', styles.errors)}>
                    {errors.FormModel?.LastName?.message}
                  </p>
                </div>
              </>
            );
          }}
        />

        <div className="form-group ">
          <label className={styles.formlabel}>{PageData?.PhoneNumber}</label>
          <div className={styles.numberwrapper}>
            <Controller
              control={control}
              name={'FormModel.CountryPrefixCode'}
              render={({ field: { onChange, name, value } }) => (
                <PrefixSelect
                  name={name}
                  value={value || defaultPrefix?.Value}
                  prefixes={Model?.CountryPrefixDropDown}
                  className={styles.numberwrapperSelect}
                  onChange={onChange}
                />
              )}
            />
            <Controller
              control={control}
              name={'FormModel.PhoneNumber'}
              render={({
                field: { onChange, name, value },
                fieldState: { isDirty, invalid, error },
              }) => {
                if (isDirty) {
                  setValuesWhenIsDirty(name, value);
                  if (invalid) {
                    setDisableContinueButton(true);
                  }
                }

                return (
                  <>
                    <input
                      {...register('FormModel.PhoneNumber', {
                        required: true,
                        minLength: {
                          value: Model?.MobilePhoneNumberMinLength,
                          message: PageData?.IncorrectMobileNumberLabel,
                        },
                        maxLength: {
                          value: Model?.MobilePhoneNumberMaxLength,
                          message: PageData?.IncorrectMobileNumberLabel,
                        },
                        onChange: handleMobileChange,
                      })}
                      type="number"
                      className={styles.numberwrapperInput}
                      onBlur={(e) =>
                        formProgression(e, 'RequestCallBack', 'PhoneNumber')
                      }
                      onKeyPress={(e) => RegexNumber(e)}
                    />
                    {value?.length >= Model?.MobilePhoneNumberMinLength &&
                      value?.length <= Model?.MobilePhoneNumberMaxLength && (
                        <Icon
                          type={SvgIcons.SUCCESS}
                          width={24}
                          className={styles.stateIcon}
                        />
                      )}
                  </>
                );
              }}
            />
          </div>
        </div>
        <div className="form-group ">
          <label className={styles.formlabel}>
            {PageData?.ReferenceNumber}
          </label>
          <Controller
            control={control}
            name={'FormModel.ReferenceNumber'}
            render={({
              field: { onChange, name, value },
              fieldState: {isDirty, invalid, error },
            }) => {
              if (isDirty) {
                setValuesWhenIsDirty(name, value);
                if (invalid) {
                  setDisableContinueButton(true);
                }
              }
              return (
                <>
                  <div className={styles.inputwrapper}>
                    <input
                      type="text"
                      name={name}
                      className="form-class"
                      value={value}
                      readOnly={Model?.FormModel?.ReferenceNumber !== null}
                      onChange={onChange}
                      onBlur={(e) =>
                        formProgression(e, 'RequestCallBack', 'ReferenceNumber')
                      }
                      onKeyPress={(e) => RegexNumber(e)}
                    />
                    {value?.length >= Model?.MobilePhoneNumberMinLength &&
                      value?.length <= Model?.MobilePhoneNumberMaxLength && (
                        <Icon
                          type={SvgIcons.SUCCESS}
                          width={24}
                          className={styles.stateIcon}
                        />
                      )}
                  </div>
                </>
              );
            }}
          />
        </div>
        <div className="form-group u-marginBz">
          <label className={styles.formSelectlabel}>
            {PageData?.SelectDateAndTime}
          </label>
        </div>
        <div
          className={classNames(
            styles.selectDT,
            allRowShowed === false && styles.showcomplete_list,
          )}
        >
          <div className={styles.selectDT_column}>
            <div className={styles.selectDT_column_heading}>
              {HourSlots?.CurrentDayTitle == 'Today'
                ? PageData?.TodayLabel
                : HourSlots?.CurrentDayTitle == 'Tomorrow'
                ? PageData?.TomorrowLabel
                : findDayTranslation(HourSlots?.CurrentDayTitle)}
              <span>
                {findMonthTranslation(HourSlots?.CurrentDateFormatted)}
              </span>
            </div>

            {timeslotsOne}
          </div>
          <div className={styles.selectDT_horiline}></div>
          <div className={styles.selectDT_column}>
            <div className={styles.selectDT_column_heading}>
              {HourSlots?.NextDayTitle == 'Tomorrow'
                ? PageData?.TomorrowLabel
                : findDayTranslation(HourSlots?.NextDayTitle)}
              <span>{findMonthTranslation(HourSlots?.NextDateFormatted)}</span>
            </div>
            {timeslotsTwo}
          </div>
        </div>
        <div className={styles.showbtndiv}>
          {allRowShowed == true ? (
            <button
              type="button"
              className={styles.selectDT_link}
              onClick={() => {
                setAllRowShowed(false);
              }}
            >
              {PageData?.ShowMoreLabel}
            </button>
          ) : (
            <button
              type="button"
              className={styles.selectDT_link}
              onClick={() => {
                setAllRowShowed(true);
              }}
            >
              {PageData?.ShowLessLabel}
            </button>
          )}
        </div>

        <>
          {ModelState?.ShowRecaptchaError && (
            <div className="form-text text-danger">
              {PageData?.ReCaptchaErrorMessage}
            </div>
          )}
        </>

        <div className="u-textcenter">
          {/* <PageLink url="" text="Callme back" className="Button w-100" /> */}
          <button
            type="submit"
            onClick={()=>setDisableContinueButton(true)}
            className={classNames(
              'Button w-100',
              styles.submitBtn,              
              ((disableContinueButton === true  ||
                isSubmitted == true) ? 'is-disabled' : '')
            )}
            disabled={(isSubmitted == true || disableContinueButton === true)}
          >
            {PageData?.CallMeBackLabel}
          </button>
        </div>
      </form>
    </>
  );
};

export default RequestCallBackForm;
